import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class ProjectTestFeedbackNewV3Api extends NewviewOaBaseApi {

    public get ControllerName(): any {
        return 'project-test-feedback-new-v3'
    }

}